import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from "react-router-dom";
import {getSingleApp} from "../api/Api";
import {useSetRecoilState} from "recoil";
import {isLoading} from "../api/Atoms";
import '../style/Single.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faStar} from '@fortawesome/free-solid-svg-icons'

import ReactMarkdown from 'react-markdown';
import DOMPurify from 'dompurify';
import {Carousel, Button} from 'antd';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';


const SingleApp = () => {
    const [googleData, setGoogleData] = useState('')
    const [appleData, setAppleData] = useState('')
    const setLoadingState = useSetRecoilState(isLoading)
    const navigate = useNavigate();



    const location = useLocation();
    let pathName = location.pathname.substring(1);

    useEffect(() => {
        setLoadingState(true)
        getSingleApp(encodeURIComponent(pathName)).then((data) => {
            if (Array.isArray(data) && data.length === 0) {
                navigate('/404');
            } else {
                setGoogleData(data.google)
                setAppleData(data.apple)
                const sanitizedMarkdown = DOMPurify.sanitize(data.google.item.description);
            }
            setLoadingState(false)

        });

    }, [location]);

    const carouselRef = React.useRef();

    const goToPrevious = () => {
        carouselRef.current.prev();
    };

    const goToNext = () => {
        carouselRef.current.next();
    };

    const goTo = (path) => {
        navigate("/" + encodeURIComponent(path))
    }

    const formatNumber = (num) => {
        //convert string to number after removing all characters except numbers
        if (typeof num === 'string') {
            num = num.replace(/\D/g, '');
        }
        if (num >= 1000000000) {
            return (num / 1000000000).toFixed(1) + 'B';
        }
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        if (num) {
            return num.toString();
        }
    }

    return (
        <div>
            {googleData === '' ? null : (
                <div className="Single-App-Container">
                    <div className="Single-App-Details">
                        <div className="Single-App-Header">
                            <div className="Details">
                                <img src={googleData.item.icon} alt={googleData.item.title}/>
                                <div>
                                    <h1>{googleData.item.title}</h1>
                                    <a target="_blank"
                                       href={googleData.item.developer_url}>{googleData.item.developer}</a>
                                </div>
                            </div>
                            <div className='Rating-Container'>
                                {googleData.item.rating.value ? <div>
                                   <span>
                                        {googleData.item.rating.value}&nbsp;
                                        <FontAwesomeIcon icon={faStar}/> </span>

                                    <span>{formatNumber(googleData.item.rating.votes_count)} ratings</span>
                                </div> : null }
                                <div>
                                    <span>{formatNumber(googleData.item.installs)}</span>
                                    <span>Downloads</span>
                                </div>
                            </div>

                        </div>
                        <div className='Single-App-Description'>
                            <ReactMarkdown children={googleData.item.description}></ReactMarkdown>
                        </div>
                        <div>
                            <div className="carousel-container">
                                <Carousel ref={carouselRef}>
                                    {googleData.item.images.map((result, index) => (
                                        <div key={index}>
                                            <img src={result} alt={googleData.item.title}/>
                                        </div>
                                    ))}
                                </Carousel>
                                <Button className="carousel-control left" onClick={goToPrevious}><LeftOutlined /></Button>
                                <Button className="carousel-control right" onClick={goToNext}><RightOutlined /></Button>
                            </div>
                        </div>
                        <div className="Buttons-Container">
                            <a className="green" href={googleData.item.url} target="_blank"><img src="/assets/googleplay.png"/>Get It From Google Play </a>
                            {appleData? <a className="blue" href={appleData.item.url} target="_blank"><img src="/assets/appstore.png"/>Get It From App Store</a> : null}
                        </div>

                        <div className="Additional-Details-Container">
                            <h2>Additional Details</h2>
                            <div className="Ditail-Wrapper">
                                <span>Category</span>
                                <Link className="Ditail-Wrapper-Link" to={`/category/${googleData.item.main_category}`}>{googleData.item.main_category}</Link>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Last Version</span>
                                <span>{googleData.item.version}</span>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Size</span>
                                <span>{googleData.item.size}</span>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Requirement Os Version</span>
                                <span>{googleData.item.minimum_os_version}</span>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Downloads</span>
                                <span>{googleData.item.installs}</span>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Package Name</span>
                                <span>{googleData.app_id}</span>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Price</span>
                                <span>{googleData.item.price.current !== 0? googleData.item.price.current + " " + googleData.item.price.currency : "Free"}</span>
                            </div>
                            <div className="Ditail-Wrapper">
                                <span>Offered By</span>
                                <span>{googleData.item.developer}</span>
                            </div>
                        </div>
                    </div>
                    {googleData.item.similar_apps ?  <div className="Similar-Apps-Container">
                        <h2>Similar Apps & Games</h2>
                        <ul>
                            {googleData.item.similar_apps.map((result, index) => (
                                <li key={index}>
                                    <div key={index} className='Similar-App-Block' onClick={() => goTo(result.title)}>
                                        <span>{index + 1}</span>
                                        <img src={result.icon} alt={result.title}/>
                                        <h3>{result.title}</h3>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div> : null}
                </div>
            )
            }

        </div>
    );
};

export default SingleApp;
